import { Plus } from 'lucide-react'
import { AnimatePresence, motion } from 'motion/react'
import { useState } from 'react'
import type { Soru } from '../icerik/tipler'
import { cn } from './ui'

export function SssAkordeon({ sorular, className }: { sorular: Soru[]; className?: string }) {
  const [acik, setAcik] = useState<number | null>(0)
  return (
    <div
      className={cn(
        'divide-y divide-line rounded-[var(--radius-panel)] bg-surface ring-soft',
        className,
      )}
    >
      {sorular.map((s, i) => {
        const bu = acik === i
        return (
          <div key={s.soru}>
            <button
              type="button"
              onClick={() => setAcik(bu ? null : i)}
              aria-expanded={bu}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[15px] font-medium text-ink hover:bg-subtle/60 sm:px-6"
            >
              {s.soru}
              <motion.span
                animate={{ rotate: bu ? 45 : 0 }}
                transition={{ duration: 0.2 }}
                className="grid size-7 shrink-0 place-items-center rounded-full bg-subtle text-ink-2"
              >
                <Plus className="size-4" aria-hidden />
              </motion.span>
            </button>
            <AnimatePresence initial={false}>
              {bu && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className="px-5 pb-5 text-[15px] leading-relaxed text-ink-2 sm:px-6">
                    {s.cevap}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        )
      })}
    </div>
  )
}
